import { ReactNode } from 'react';

import { CmsDownload } from '~modules/downloads/CmsDownload';

type CmsFileProps = {
  assetId: string;
  description?: ReactNode;
};

export function CmsFile({ assetId, description }: CmsFileProps) {
  if (assetId) {
    return <CmsDownload entityId={assetId} description={description} />;
  }

  return null;
}
